import { render, staticRenderFns } from "./RawMaterialView.vue?vue&type=template&id=3f1fcf04&scoped=true"
import script from "./RawMaterialView.vue?vue&type=script&lang=js"
export * from "./RawMaterialView.vue?vue&type=script&lang=js"
import style0 from "./RawMaterialView.vue?vue&type=style&index=0&id=3f1fcf04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1fcf04",
  null
  
)

export default component.exports